import { useDialog } from '@works-web/settings/modules/dialog';
import { useToast } from '@works-web/settings/modules/toast';
import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { CheckboxGroup, Toggle } from '~/settings/__modules__/component';
import Icon_loading from '~/settings/__modules__/images/icon_loading.gif';
import { StampBiz } from '~/settings/biz/StampBiz';
import { AppData } from '~/settings/service/CommonService';

export function Stamp() {
  const { t } = useTranslation();
  const toast = useToast();
  const dialog = useDialog();
  const StampSuggestionExist = AppData.StampSuggestionExist;
  const [hasLocalData, setHasLocalData] = useState(StampSuggestionExist);
  const [loading, setLoading] = useState(false);
  const [enabled, setEnable] = useState(StampBiz.getStampEnable());
  const [languageOptions, setLanguageOptions] = useState([]);

  const save = function (params) {
    StampBiz.save(params)
      .then((isSuccess) => {
        if (isSuccess) {
          toast(<Trans i18nKey={'saved'} />);
          setEnable(params.enabled);
          setLanguageOptions(params.languageOptions);
        } else {
          dialog.alert((action) => ({
            title: <Trans i18nKey="error_unknown_title" />,
            description: <Trans i18nKey="error_unknown_description" />,
            [action()]: (close) => {
              close && close();
            },
          }));
        }
      })
      .catch(() => {
        dialog.alert((action) => ({
          title: <Trans i18nKey="error_unknown_title" />,
          description: <Trans i18nKey="error_unknown_description" />,
          [action()]: (close) => {
            close && close();
          },
        }));
      });
  };

  const downloadStamp = async function () {
    if (hasLocalData) return;
    setLoading(true);
    StampBiz.download()
      .then((isSuccess) => {
        setLoading(false);
        setHasLocalData(isSuccess);
        AppData.StampSuggestionExist = isSuccess;
        localStorage.setItem('StampSuggestionExist', isSuccess.toString());
        localStorage.setItem('supportStampSuggestion', 'true');
        if (!isSuccess) {
          toast(<Trans i18nKey={'talk_main_toast_error'} />);
        } else {
          toast(<Trans i18nKey={'talk_main_toast_download'} />);
        }
      })
      .catch((err) => {
        console.log(err);
        toast(<Trans i18nKey={'talk_main_toast_error'} />);
        setLoading(false);
      });
  };

  const enableLanguageItem = (checkedList) => {
    let options = languageOptions.map((item) => {
      item.enable = checkedList.includes(item.value);
      return item;
    });
    let params = {
      enabled: enabled,
      languageOptions: options,
    };
    save(params);
  };

  const onEnable = (enable) => {
    let noChecked = languageOptions.every((x) => !x.enable); // 没有被选中项
    let options = [...languageOptions];
    if (enable && noChecked) {
      options.forEach((x) => (x.enable = true));
    }
    let params = {
      enabled: enable,
      languageOptions: options,
    };
    save(params);
    enable && downloadStamp(enable);
  };

  React.useEffect(() => {
    StampBiz.getLangOptions().then((response) => {
      setLanguageOptions(response);
    });
  }, []);

  let enableLanguage = languageOptions
    .filter((item) => item.enable)
    .map((item) => item.value);

  return (
    <div className="settings_cover">
      <h3 className="title">
        <span className="text">{t('talk_main_stickertitle')}</span>
      </h3>
      <ul className="settings_list">
        <li className="item">
          <div className="title_area">
            <h4 className="title">
              <span className="text">
                <Trans i18nKey="talk_main_stickersug" />
              </span>
            </h4>
          </div>
          <div className="task_area">
            <Toggle
              value={enabled}
              label={t('talk_main_stickersug')}
              onChange={() => onEnable(!enabled)}
            />
          </div>
          <div
            className="loading"
            style={{ display: loading ? 'block' : 'none' }}
          >
            <em>{t('talk_main_stickerdownload')}</em>
            <img src={Icon_loading} width="32" height="8" alt="downloading" />
          </div>
          {enabled && (
            <ul className="sub_list">
              <li className="item">
                <div className="title_area">
                  <h4 className="title">
                    <span className="text">{t('talk_main_stickerlang')}</span>
                  </h4>
                </div>

                <CheckboxGroup
                  onChange={(list) => enableLanguageItem(list)}
                  value={enableLanguage}
                  options={languageOptions}
                />
                <div
                  className={`notification ${
                    languageOptions.length === 0 ? 'language_error' : ''
                  }`}
                  style={{
                    display: !hasLocalData && !loading ? 'block' : 'none',
                  }}
                >
                  <p>
                    <Trans i18nKey="talk_main_stickerguide1" />
                  </p>
                  <button
                    type="button"
                    className="lw_btn_point_32"
                    onClick={() => downloadStamp()}
                  >
                    {t('talk_button_download')}
                  </button>
                </div>
              </li>
            </ul>
          )}
        </li>
      </ul>
    </div>
  );
}
